import { IAbstractAuditing } from '@model/abstract-auditing.model';
import { IDocumentClient } from '@model/client/document-client.model';
import { IEmailContactClient } from '@model/client/email-contact-client.model';
import { IForeignAddressClient } from '@model/client/foreign-address-client.model';
import { IInstitutionClient } from '@model/client/institution-client.model';
import { IPhoneContactClient } from '@model/client/phone-contact-client.model';
import { IPortugueseAddressClient } from '@model/client/portuguese-address-client.model';
import { ISocialNetworkClient } from '@model/client/social-network-client.model';

export interface IInstitutionBDUInfo extends IAbstractAuditing {
  institutionClient?: IInstitutionClient;
  emails?: IEmailContactClient[];
  phones?: IPhoneContactClient[];
  foreignAddress?: IForeignAddressClient[];
  portugueseAddress?: IPortugueseAddressClient[];
  documents?: IDocumentClient[];
  socialNetworks?: ISocialNetworkClient[];
  institutionAddress?: string;
}

// noinspection JSUnusedGlobalSymbols
export class InstitutionInfo implements IInstitutionBDUInfo {
  constructor(
    public institutionClient?: IInstitutionClient,
    public emails?: IEmailContactClient[],
    public phones?: IPhoneContactClient[],
    public foreignAddress?: IForeignAddressClient[],
    public portugueseAddress?: IPortugueseAddressClient[],
    public documents?: IDocumentClient[],
    public socialNetworks?: ISocialNetworkClient[],
    public institutionAddress?: string
  ) {}
}
